<template>
    <div class="nav-item">
        <router-link v-if="item.to" :to="item.to" :title="item.label" :class="item.class">
            <svg-icon :icon="item.icon" />
            <span :style="item.count ? 'flex:1' : ''">{{ item.label }}<span v-if="item.aiTag" class="ai-tag">AI</span></span>
            <span v-if="item.count" class="menu-count">{{ item.count }}</span>
        </router-link>
        <a v-else-if="item.href" :href="item.href" target="_blank" :title="item.label" :class="item.class">
            <svg-icon :icon="item.icon" />
            <span>{{ item.label }}</span>
        </a>
        <a v-else @click.prevent="item.action()" :title="item.label" :class="item.class">
            <svg-icon :icon="item.icon" />
            <span>{{ item.label }}</span>
        </a>
        <button v-if="showStar" type="button" :class="favorite ? 'nav-fav on' : 'nav-fav'" :title="favorite ? 'Remove from favorites' : 'Add to favorites'" @click="$emit('toggle-favorite', item.key)">
            <svg-icon :icon="favorite ? 'starfilled' : 'star'" />
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';

// One nav menu entry. `item` comes from navItems in App.vue:
// { key, label, icon, to? (router path) | href? (new tab) | action? (click handler), count?, aiTag?, class? }
export default defineComponent({
    name: 'NavItem',
    props: ['item', 'favorite', 'showStar'],
    emits: ['toggle-favorite'],
    components: {
        SvgIcon
    }
});
</script>
